import React from "react";
import { Icon, message } from "antd";

import Icons from "components/icons";
import { Localize } from "components/service";
import { useTranslation } from "components/use-hooks";
import { getAttachmentFileName, getAttachmentPath } from "utils/attachment";
import { copyText } from "utils/copy-content";
import useAttachmentActions from "./use-attachment-actions";

import "./attachment-actions.css";

export const isAttachmentPrimaryClick = event => (
    !event.defaultPrevented && event.button === 0 &&
    !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
);

const AttachmentActions = ({ attachment, showText = true, download = false, children }) => {
    const { open, loading, errors } = useAttachmentActions(attachment.id);
    const translations = useTranslation();
    const pending = Boolean(loading[attachment.id]);
    const error = errors[attachment.id];
    const path = getAttachmentPath(attachment.id);

    const copy = () => {
        try {
            if (!copyText(window.location.origin + path)) throw new Error("Copy failed");
            message.success(translations["ATTACHMENTS.Text_LinkCopied"]);
        } catch (_) {
            message.error(translations["ATTACHMENTS.Error_CopyLink"]);
        }
    };

    return (
        <div className={`attachment-actions${showText ? "" : " attachment-actions--icon-only"}`}>
            <div className="attachment-action-buttons">
                <a
                    href={path}
                    className="attachment-action-button download-button button-bg-color"
                    target="_blank"
                    rel="noopener noreferrer"
                    title={getAttachmentFileName(attachment)}
                    aria-label={translations["POST.Link_Text_DownloadAttachment"]}
                    aria-disabled={pending}
                    aria-busy={pending}
                    onClick={event => {
                        if (!isAttachmentPrimaryClick(event)) return;
                        event.preventDefault();
                        open(attachment, { download });
                    }}
                >
                    <Icons.Download loading={pending} />
                    {showText && <Localize wrap>POST.Link_Text_DownloadAttachment</Localize>}
                </a>
                <button
                    type="button"
                    className="attachment-action-button attachment-copy-button button-bg-color"
                    onClick={copy}
                    title={translations["MENUS.Button_Text_CopyLink"]}
                    aria-label={translations["MENUS.Button_Text_CopyLink"]}
                >
                    <Icon type="link" />
                    {showText && <Localize wrap>MENUS.Button_Text_CopyLink</Localize>}
                </button>
                {children}
            </div>
            {error && (
                <div className="attachment-action-error" role="alert">
                    <Localize>{error}</Localize>
                    <button type="button" className="company-color" disabled={pending} onClick={() => open(attachment, { download })}>
                        <Localize>ATTACHMENTS.Button_Retry</Localize>
                    </button>
                </div>
            )}
        </div>
    );
};

export default AttachmentActions;
